import React from 'react';
import { App as Routes } from './routes/App';

export const App = () => {
  return (
    <Routes />
  )
}